import logoMainForm from "../../assets/images/logo-main-form.png";
import { useState, useRef, useContext } from "react";
import { MessageForm } from "./widgets/MessageForm";
import { InputMask } from "primereact/inputmask";
import { getValueFromInputElement } from "../../utils/inputRefHandlers";
import { setStatusFormAlert } from "../../hooks/AlertsForm";
import {
  userRegistration,
  userAuthentication,
} from "../../api/user/userService";
import { Context } from "../../App";

export function Register(props) {//sadsadasdqwwefgcvbcvb
  const { setAndGetUserData } = useContext(Context);

  const { setSessionForm } = props;
  const inputRefs = useRef({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  const [hasProcessingInformation, setHasProcessingInformation] = useState(false);

  const [formRequestStatus, setFormRequestStatus] = useState({
    typeAlert: "",
    message: "",
  });
  const timeToRemoveMessage = useRef(0);

  async function loginUserAfterRegistration(credentialUser) {
    userAuthentication(credentialUser).then((data) => {
      let statusHttp = data["statusHttp"];
      if (statusHttp === 200) {
        setStatusFormAlert(
          data,
          "alert-success",
          setFormRequestStatus,
          timeToRemoveMessage
        );

        let response = {"data": data.user_data};
        setAndGetUserData(response);
      }
    });
  }

  const handleRegister = async (e) => {
    e.preventDefault();

    const name = inputRefs.current["name"];
    const email = inputRefs.current["email"];
    const phone = inputRefs.current["phone"];
    const password = inputRefs.current["password"];
    const confirm_password = inputRefs.current["confirm_password"];

    let dataToRegister = {
      nome: name,
      email: email,
      phone: phone,
      senha: password,
      csenha: confirm_password,
    };

    setHasProcessingInformation(true);

    userRegistration(dataToRegister).then((data) => {
      setHasProcessingInformation(false);
      let statusHttp = data["statusHttp"];

      if (statusHttp === 201) {
        setStatusFormAlert(
          data,
          "alert-success",
          setFormRequestStatus,
          timeToRemoveMessage
        );

        let newLoginCredentials = {
          email: email,
          senha: confirm_password,
        };
        loginUserAfterRegistration(newLoginCredentials);
      } else if (statusHttp === 0) {
        let typeAlert = "alert-danger";
        setStatusFormAlert(
          data,
          typeAlert,
          setFormRequestStatus,
          timeToRemoveMessage
        );
      } else {
        setHasProcessingInformation(false);
        if (statusHttp === 400 || statusHttp === 409) {
          setStatusFormAlert(
            data,
            "alert-danger",
            setFormRequestStatus,
            timeToRemoveMessage
          );
        }
      }
    });
  };

  return (
    <div className="home-px-5 d-flex align-items-center justify-content-center home-container-form">
      <div className="home-area-form">
        <span className="home-container-main-icon-form">
          <img
            src={logoMainForm}
            alt="Ícone de parceiros"
            className="home-main-icon-form"
          />
        </span>

        <br />
        <MessageForm
          formRequestStatus={formRequestStatus}
          hasProcessingInformation={hasProcessingInformation}
        />
        <br />

        <span className="home-form-title">Cadastrar</span>
        <div>
          <form className="w-100" onSubmit={handleRegister}>
            <div className="home-field-form-to-fill" data-validate="Enter name">
              <input
                className="home-input-form"
                type="text"
                name="name"
                placeholder="Nome"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="👤"
              ></span>
            </div>

            <div
              className="home-field-form-to-fill"
              data-validate="Enter email"
            >
              <input
                className="home-input-form"
                type="email"
                name="email"
                placeholder="E-mail"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="📧"
              ></span>
            </div>

            <div
              className="home-field-form-to-fill"
              data-validate="Enter Phone"
            >
              <InputMask
                className="home-input-form"
                mask="(99) 9 9999-9999"
                type="tel"
                name="phone"
                placeholder="Telefone"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="📱"
              ></span>
            </div>

            <div
              className="home-field-form-to-fill"
              data-validate="Enter password"
            >
              <input
                className="home-input-form"
                type="password"
                name="password"
                placeholder="Senha"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="🔐"
              ></span>
            </div>

            <div
              className="home-field-form-to-fill"
              data-validate="Enter password"
            >
              <input
                className="home-input-form "
                type="password"
                name="confirm_password"
                placeholder="Confirmar Senha"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="🔑"
              ></span>
            </div>

            <div className="home-form-container-check">
              <p>
                <input type="checkbox" required />
                <a href="/termoscondicoes" className="home-form-link">
                  Termos e Condições
                </a>
              </p>
            </div>

            <div className="home-container-btn-submit-form">
              <button className="home-btn-submit-form" type="submit">
                Cadastrar
              </button>
            </div>
            <hr />
          </form>
          <div className="text-center">
            <div className="home-sub-container-other-option-form">
              <div className="col ">
                <a
                  className="home-text-other-option-form"
                  onClick={() => {
                    setSessionForm("login");
                  }}
                >
                  <p>Já possui cadastro? Entre agora.</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}